import { PRODUCT_TYPE } from '../common/constants/productType'
import { MANAGING_TEAMS_TOPIC_ID } from '../essentials/constants'
import { isLanguageEnglish } from '../intl/utils/isLanguageEnglish'

export const isManagingTeamsTopicDisabled = (disableSelfCareTopics?: string): boolean =>
  disableSelfCareTopics?.split(';').some((topicId) => topicId.trim() === MANAGING_TEAMS_TOPIC_ID) ?? false

export interface ManagerHubEligibilityParams {
  isManagerHubEnabled: boolean
  productType?: PRODUCT_TYPE
  isUserMinor?: boolean
  language?: string
  isEssentialsEnabled?: boolean
  disableSelfCareTopics?: string
}

export const isEligibleForManagerHub = ({
  isManagerHubEnabled,
  productType,
  isUserMinor = false,
  language,
  isEssentialsEnabled,
  disableSelfCareTopics,
}: ManagerHubEligibilityParams): boolean =>
  isManagerHubEnabled &&
  isEssentialsEnabled === true &&
  productType === PRODUCT_TYPE.WFMH &&
  !isUserMinor &&
  isLanguageEnglish(language ?? '') &&
  !isManagingTeamsTopicDisabled(disableSelfCareTopics)
